import React from "react";

// Material UI
import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

import { DRAWER_WIDTH } from "common/constants/ui";
import { usePopups } from "hooks";
import { AuthContext } from "store/auth/authContext";
// Custom Imports
import Appbar from "./appbar";
import ApplicationRoutes from "./routes/ApplicationRoutes";
import SideMenu from "./sidemenu";

import BannerMessage from "components/bannerMessage";
import Auth from "s12-library/auth/Auth";

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
}));

const Main = styled("main")(({ theme }) => ({
  marginLeft: DRAWER_WIDTH,
  width: `calc(100vw - ${DRAWER_WIDTH})`,
  height: "100vh",
  padding: theme.spacing(1),
}));

const Layout: React.FC = () => {
  const classes = useStyles();
  const { handleSnackbar } = usePopups();

  // Title bar to environment
  switch (process.env.REACT_APP_ENV) {
    case "dev":
      document.title = "S12 Claims - Development";
      break;
    case "preprod":
      document.title = "S12 Claims - Preprod";
      break;
    case "sandbox":
      document.title = "S12 Claims - Sandbox";
      break;
    default:
      document.title = "S12 Claims";
      break;
  }

  return (
    <Auth context={AuthContext} handleSnackbar={handleSnackbar} enabledUserGroups={["OrgClaims"]}>
      <>
        <Appbar />
        <SideMenu />
        <Main>
          <div className={classes.appBarSpacer} />
          <BannerMessage />
          <ApplicationRoutes />
        </Main>
      </>
    </Auth>
  );
};

export default React.memo(Layout);
